import { FC } from 'react';
import { useMasterData } from '@nextgen-web-framework/all';
import { Config } from '@com.amway.commerce/webshop-configs-v1-prod/Schema';
import FooterNavigation from '../footerNavigation/FooterNavigation';
import LegalLink from '../legalLink/LegalLink';
import SocialIcon from '../socialIcon/SocialIcon';
import FooterLanguage from '../FooterLanguage/FooterLanguage';
import type { FooterProps } from './types/propsTypes';

const Footer: FC<FooterProps> = ({
  footer,
  hideFooterNavigation,
  hideLegalLink,
  hideSocialIcon,
  langHandler,
  locale,
}) => {
  const webShopConfigs = useMasterData<Config>('WebshopConfigs') as Config;
  return (
    <div>
      {!hideFooterNavigation && <FooterNavigation footerData={footer.footerData} helpingData={footer.helpingData} />}
      {!hideSocialIcon && <SocialIcon socialIcon={footer.footerIcon} />}
      {webShopConfigs?.locales?.length > 1 && <FooterLanguage langHandler={langHandler} locale={locale} />}
      {!hideLegalLink && <LegalLink legalLink={footer.legalLink} />}
    </div>
  );
};
export default Footer;
